import React from 'react';

function NotFound(props) {
    return (
        <p>404 - Page not found</p>
    );
}
export default NotFound;